// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Video__container-f82498 {
  position: relative;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  background-color: var(--base-17);
}

.Video__preview-cda9ef {
  width: 100%;
}

.Video__icon-container-a9b090 {
  color: var(--addition-50);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  background-color: var(--addition-40_60);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  cursor: pointer;
}

.Video__icon-c09e97 {
  fill: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/ArticlePreview/Payloads/Video/styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n  border-radius: 16px;\n  overflow: hidden;\n  background-color: var(--base-17);\n}\n\n.preview {\n  width: 100%;\n}\n\n.icon-container {\n  color: var(--addition-50);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  background-color: var(--addition-40_60);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.icon {\n  fill: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Video__container-f82498`,
	"preview": `Video__preview-cda9ef`,
	"icon-container": `Video__icon-container-a9b090`,
	"iconContainer": `Video__icon-container-a9b090`,
	"icon": `Video__icon-c09e97`
};
module.exports = ___CSS_LOADER_EXPORT___;
